module.exports = __webpack_public_path__ + "static/media/ic-pause.e30ce3a5.png";